import React from 'react';
import { motion } from 'framer-motion';
import { Target, Eye, Award, Shield, Star } from 'lucide-react';
export function MissionVision() {
  return <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white" data-id="element-275">
      <div className="container mx-auto px-4 md:px-6" data-id="element-276">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto" data-id="element-277">
          {/* Awards Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} whileHover={{
          y: -8,
          transition: {
            duration: 0.3
          }
        }} className="group relative bg-white rounded-3xl p-8 md:p-10 shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-100 overflow-hidden" data-id="element-278">
            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-279" />

            <div className="relative z-10" data-id="element-280">
              <motion.div whileHover={{
              rotate: 360,
              scale: 1.1
            }} transition={{
              duration: 0.6,
              ease: 'easeInOut'
            }} className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-500 to-amber-600 rounded-2xl mb-6 shadow-lg shadow-yellow-500/20" data-id="element-281">
                <Award className="w-8 h-8 text-white" data-id="element-282" />
              </motion.div>

              <h2 className="text-3xl md:text-4xl font-bold text-brand-black mb-6" data-id="element-283">
                Award <span className="text-yellow-600" data-id="element-284">Winning</span>
              </h2>

              {/* Awards List */}
              <div className="space-y-4" data-id="element-285">
                <div className="flex items-start gap-3" data-id="element-286">
                  <div className="flex-shrink-0 w-8 h-8 bg-yellow-50 rounded-lg flex items-center justify-center mt-0.5" data-id="element-287">
                    <Shield className="w-4 h-4 text-yellow-600" data-id="element-288" />
                  </div>
                  <div data-id="element-289">
                    <p className="font-semibold text-brand-black text-sm" data-id="element-290">
                      NAICOM Certified
                    </p>
                    <p className="text-gray-600 text-sm" data-id="element-291">
                      Fully licensed insurance broker
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-292">
                  <div className="flex-shrink-0 w-8 h-8 bg-yellow-50 rounded-lg flex items-center justify-center mt-0.5" data-id="element-293">
                    <Star className="w-4 h-4 text-yellow-600" data-id="element-294" />
                  </div>
                  <div data-id="element-295">
                    <p className="font-semibold text-brand-black text-sm" data-id="element-296">
                      Industry Excellence
                    </p>
                    <p className="text-gray-600 text-sm" data-id="element-297">
                      Recognized for service quality
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-298">
                  <div className="flex-shrink-0 w-8 h-8 bg-yellow-50 rounded-lg flex items-center justify-center mt-0.5" data-id="element-299">
                    <Award className="w-4 h-4 text-yellow-600" data-id="element-300" />
                  </div>
                  <div data-id="element-301">
                    <p className="font-semibold text-brand-black text-sm" data-id="element-302">
                      Client Satisfaction
                    </p>
                    <p className="text-gray-600 text-sm" data-id="element-303">96% success rating</p>
                  </div>
                </div>
              </div>

              {/* Decorative element */}
              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-br from-yellow-500/5 to-transparent rounded-tl-full transform translate-x-16 translate-y-16 group-hover:scale-150 transition-transform duration-500" data-id="element-304" />
            </div>
          </motion.div>

          {/* Mission Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} whileHover={{
          y: -8,
          transition: {
            duration: 0.3
          }
        }} className="group relative bg-white rounded-3xl p-8 md:p-10 shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-100 overflow-hidden" data-id="element-305">
            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-red-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-306" />

            <div className="relative z-10" data-id="element-307">
              <motion.div whileHover={{
              rotate: 360,
              scale: 1.1
            }} transition={{
              duration: 0.6,
              ease: 'easeInOut'
            }} className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl mb-6 shadow-lg shadow-red-500/20" data-id="element-308">
                <Target className="w-8 h-8 text-white" data-id="element-309" />
              </motion.div>

              <h2 className="text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-310">
                Our <span className="text-brand-red" data-id="element-311">Mission</span>
              </h2>

              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-312">
                To offer unmatched risk solutions and act at all times in the
                best interest of our clients, leveraging innovation and
                technology.
              </p>

              {/* Decorative element */}
              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-br from-red-500/5 to-transparent rounded-tl-full transform translate-x-16 translate-y-16 group-hover:scale-150 transition-transform duration-500" data-id="element-313" />
            </div>
          </motion.div>

          {/* Vision Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} whileHover={{
          y: -8,
          transition: {
            duration: 0.3
          }
        }} className="group relative bg-white rounded-3xl p-8 md:p-10 shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-100 overflow-hidden md:col-span-2 lg:col-span-1" data-id="element-314">
            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-red-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-315" />

            <div className="relative z-10" data-id="element-316">
              <motion.div whileHover={{
              rotate: 360,
              scale: 1.1
            }} transition={{
              duration: 0.6,
              ease: 'easeInOut'
            }} className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl mb-6 shadow-lg shadow-red-500/20" data-id="element-317">
                <Eye className="w-8 h-8 text-white" data-id="element-318" />
              </motion.div>

              <h2 className="text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-319">
                Our <span className="text-brand-red" data-id="element-320">Vision</span>
              </h2>

              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-321">
                To be a global insurance brand, known for service excellence and
                premium risk solutions, leveraging cutting-edge technology and
                innovation.
              </p>

              {/* Decorative element */}
              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-br from-red-500/5 to-transparent rounded-tl-full transform translate-x-16 translate-y-16 group-hover:scale-150 transition-transform duration-500" data-id="element-322" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}